module.exports = __webpack_public_path__ + "img/client1.ee147454.jpg";